module.exports = __webpack_public_path__ + "img/MasterPeace_Icon.99e5c723.png";